<template>
    <div>
        <p :class="titleClass || titleClassDefault">{{ 'Choose country' | translation }}</p>
        <v-select
            :items="sortedCountries"
            item-text="name"
            item-value="iso_2"
            solo
            v-model="selectedCountry"
        >
            <template slot="selection" slot-scope="data">
                <v-flex xs2>
                    <span :class="'flag-icon flag-icon-' + data.item.iso_2.toLowerCase()"></span>
                </v-flex>
                <v-flex class='ml-1'>
                    {{ data.item.name }}
                </v-flex>
            </template>
            <template slot="item" slot-scope="data">
                <v-list-tile-avatar tile>
                    <span :class="'flag-icon flag-icon-' + data.item.iso_2.toLowerCase()"></span>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                </v-list-tile-content>
            </template>
        </v-select>
    </div>
</template>

<script>
    const moduleName = 'CountrySwitcher';

    export default {
        name: moduleName,
        props: {
            titleClass: String | Array,
        },
        computed: {
            selectedCountry: {
                get(){
                    return this.$country.getCountry();
                },
                set(value) {
                    this.$country.setCountry(value);
                }
            },
            sortedCountries()  {
                let normalCountries = Object.values(this.$country.getCountries());
                let favoriteCountries = [];
                let allSortedCountries = [];
                normalCountries = normalCountries.filter(function(country)    {
                    if(country.isFavorite === true) {
                        favoriteCountries.push(country);
                    }
                    else    {
                        return true;
                    }
                });
                normalCountries.sort(function(a,b)  {
                    return ( ( a.name == b.name ) ? 0 : ( ( a.name > b.name ) ? 1 : -1 ) );
                });
                favoriteCountries.sort(function(a,b)  {
                    return ( ( a.name == b.name ) ? 0 : ( ( a.name > b.name ) ? 1 : -1 ) );
                });
                allSortedCountries = [...favoriteCountries, ...normalCountries];
                return allSortedCountries;
            },
            titleClassDefault() {
                return this.$vuetify.breakpoint.smAndDown ? 'title' : 'display-1';
            },
        },
    };
</script>